import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logIn } from "./redux/user/userActions";

function Protected(props) {
  const dispatch = useDispatch();
  var storedUserUid = localStorage.getItem("userUid");
  if (storedUserUid) {
    dispatch(logIn(storedUserUid));
  }

  return <>{storedUserUid ? <Outlet /> : <Navigate to="/login" />}</>;
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps)(Protected);
